import { status } from 'skin/event/status';

const list = (obj, form, story, data, d, action) => {
	console.log('[def форма] событие', obj);
	if(obj.type === 'control' && !obj.table ) return status.ignore
    return status.action
};

export default list;
